var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMiniPollIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2565 0.12915H2.92318C1.63984 0.12915 0.589844 1.17915 0.589844 2.46248V18.7958C0.589844 20.0791 1.63984 21.1292 2.92318 21.1292H19.2565C20.5398 21.1292 21.5898 20.0791 21.5898 18.7958V2.46248C21.5898 1.17915 20.5398 0.12915 19.2565 0.12915ZM19.2565 18.7958H2.92318V2.46248H19.2565V18.7958ZM5.25651 8.29582H7.58984V16.4625H5.25651V8.29582ZM9.92318 4.79582H12.2565V16.4625H9.92318V4.79582ZM14.5898 11.7958H16.9232V16.4625H14.5898V11.7958Z",
    fill: "#0C62FB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiniPollIcon);
export default __webpack_public_path__ + "static/media/mini-poll-icon.39bcdcac5a23bafe367e6ccf5856fe30.svg";
export { ForwardRef as ReactComponent };